import React from 'react';
import * as Styled from './style';

export default function StepFinal() {
  return (
    <Styled.Centered>
      {/* <Styled.Icon src={chatbotIcon} alt="chatbot icon" /> */}

      <Styled.Title>Thank you!</Styled.Title>

      <Styled.Paragraph>
        The information you provided in this form will be used to train your AI
        Chatbot to accurately represent your law firm and answer questions on
        your behalf.
        <br />
        <br />
        You are not locked into the responses you provided here. During your
        Demo or Onboarding session, we’ll review your submission together and
        make any necessary adjustments to ensure your chatbot reflects your
        practice accurately.
        <br />
        <br />
        You’ll also be able to update, add to, or improve your chatbot’s
        responses at any time — this is just the starting point.
      </Styled.Paragraph>
    </Styled.Centered>
  );
}
